module.exports = __webpack_public_path__ + "src/assets/images/volums/sound/volum_circle5.png?c1bc06f13b4e8a3fecf814afeeec7683";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/sound/volum_circle5.png
// module id = 679
// module chunks = 0